module.exports = __webpack_public_path__ + "static/media/snowglobe-desktop.4ef332e3.png";